"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allOptions = exports.sections = exports.availableFontSizeOptions = exports.availableEditorHistoryOptions = exports.availableEditorLinkOptions = exports.availableEditorTextAlignOptions = exports.availableEditorListOptions = exports.availableEditorBlockTypeOptions = exports.availableEditorInlineOptions = exports.availableEditorOptions = void 0;
const editor_type_1 = require("./editor.type");
exports.availableEditorOptions = [
    editor_type_1.BronsonEditorOptions.inline,
    editor_type_1.BronsonEditorOptions.blockType,
    editor_type_1.BronsonEditorOptions.fontSize,
    editor_type_1.BronsonEditorOptions.list,
    editor_type_1.BronsonEditorOptions.textAlign,
    editor_type_1.BronsonEditorOptions.colorPicker,
    editor_type_1.BronsonEditorOptions.link,
    editor_type_1.BronsonEditorOptions.embedded,
    editor_type_1.BronsonEditorOptions.emoji,
    editor_type_1.BronsonEditorOptions.image,
    editor_type_1.BronsonEditorOptions.remove,
    editor_type_1.BronsonEditorOptions.history,
];
exports.availableEditorInlineOptions = [
    editor_type_1.BronsonEditorInlineOptions.bold,
    editor_type_1.BronsonEditorInlineOptions.italic,
    editor_type_1.BronsonEditorInlineOptions.underline,
    editor_type_1.BronsonEditorInlineOptions.strikethrough,
    editor_type_1.BronsonEditorInlineOptions.monospace,
    editor_type_1.BronsonEditorInlineOptions.superscript,
    editor_type_1.BronsonEditorInlineOptions.subscript,
];
exports.availableEditorBlockTypeOptions = [
    editor_type_1.BronsonEditorBlockTypeOptions.Normal,
    editor_type_1.BronsonEditorBlockTypeOptions.H1,
    editor_type_1.BronsonEditorBlockTypeOptions.H2,
    editor_type_1.BronsonEditorBlockTypeOptions.H3,
    editor_type_1.BronsonEditorBlockTypeOptions.H4,
    editor_type_1.BronsonEditorBlockTypeOptions.H5,
    editor_type_1.BronsonEditorBlockTypeOptions.H6,
    editor_type_1.BronsonEditorBlockTypeOptions.Blockquote,
    editor_type_1.BronsonEditorBlockTypeOptions.Code,
];
exports.availableEditorListOptions = [
    editor_type_1.BronsonEditorListOptions.unordered,
    editor_type_1.BronsonEditorListOptions.ordered,
    editor_type_1.BronsonEditorListOptions.indent,
    editor_type_1.BronsonEditorListOptions.outdent,
];
exports.availableEditorTextAlignOptions = [
    editor_type_1.BronsonEditorTextAlignOptions.left,
    editor_type_1.BronsonEditorTextAlignOptions.center,
    editor_type_1.BronsonEditorTextAlignOptions.right,
    editor_type_1.BronsonEditorTextAlignOptions.justify,
];
exports.availableEditorLinkOptions = [
    editor_type_1.BronsonEditorLinkOptions.unlink,
    editor_type_1.BronsonEditorLinkOptions.link,
];
exports.availableEditorHistoryOptions = [
    editor_type_1.BronsonEditorHistoryOptions.undo,
    editor_type_1.BronsonEditorHistoryOptions.redo,
];
exports.availableFontSizeOptions = [
    editor_type_1.BronsonEditorFontSizeOptions.seven,
    editor_type_1.BronsonEditorFontSizeOptions.sevenPlus,
    editor_type_1.BronsonEditorFontSizeOptions.eight,
    editor_type_1.BronsonEditorFontSizeOptions.eightPlus,
    editor_type_1.BronsonEditorFontSizeOptions.nine,
    editor_type_1.BronsonEditorFontSizeOptions.ninePlus,
    editor_type_1.BronsonEditorFontSizeOptions.ten,
    editor_type_1.BronsonEditorFontSizeOptions.tenPlus,
    editor_type_1.BronsonEditorFontSizeOptions.eleven,
    editor_type_1.BronsonEditorFontSizeOptions.elevenPlus,
    editor_type_1.BronsonEditorFontSizeOptions.twelve,
    editor_type_1.BronsonEditorFontSizeOptions.twelvePlus,
    editor_type_1.BronsonEditorFontSizeOptions.fourteen,
    editor_type_1.BronsonEditorFontSizeOptions.sixteen,
    editor_type_1.BronsonEditorFontSizeOptions.eighteen,
    editor_type_1.BronsonEditorFontSizeOptions.twenty,
    editor_type_1.BronsonEditorFontSizeOptions.twentyFour,
    editor_type_1.BronsonEditorFontSizeOptions.twentySix,
    editor_type_1.BronsonEditorFontSizeOptions.thirty,
];
exports.sections = [
    'inline',
    'blockType',
    'list',
    'textAlign',
    'link',
    'history',
    'fontSize',
];
exports.allOptions = {
    inline: exports.availableEditorInlineOptions,
    blockType: exports.availableEditorBlockTypeOptions,
    list: exports.availableEditorListOptions,
    textAlign: exports.availableEditorTextAlignOptions,
    link: exports.availableEditorLinkOptions,
    history: exports.availableEditorHistoryOptions,
    fontSize: exports.availableFontSizeOptions,
};
